const CODE_FENCE_RE = /^```(?:markdown|md)?\n?([\s\S]*?)\n?```$/;

export function stripCodeFences(text: string): string {
    const match = CODE_FENCE_RE.exec(text.trim());
    return match?.[1] ?? text;
}
